<template>
  <div class="auth">
        <div class="container">
            <div class="auth__inner">
                <div class="auth__head">
                    <div class="auth__preview">
                        <img src="/static/img/logo-color.svg" alt="" class="auth__preview__img">
                    </div>
                </div>
                <form class="auth__body">
                    <advertiser></advertiser>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import AdvertiserForm from './advertiser'

export default {
  name: 'Signup',
  data () {
    return {
      profile: {
        country: 0
      },
      action: 'Create'
    }
  },
  head: {
    title: {
      inner: 'Signup',
      separator: '-',
      complement: 'Ad Operator'
    },
    meta: [
      {
        name: 'description',
        content: 'Signup page Ad Operator'
      },
      {
        name: 'keywords',
        content: 'Signup'
      },
      {
        property: 'og:title',
        content: 'Signup - Ad Operator'
      },
      {
        property: 'og:image',
        content: '/static/favicon/android-icon-192x192.png'
      },
      {
        property: 'og:url',
        content: 'https://adop.co/signup'
      },
      {
        property: 'og:description',
        content: 'Signup page Ad Operator'
      }
    ],
    link: [
      {
        rel: 'canonical',
        h: 'https://adop.co/signup',
        id: 'canonical'
      }
    ]
  },
  components: {
    advertiser: AdvertiserForm
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/account/signup.vue